import { render, staticRenderFns } from "./ApexRadarChart.vue?vue&type=template&id=38d122b6&scoped=true&"
import script from "./ApexRadarChart.vue?vue&type=script&lang=js&"
export * from "./ApexRadarChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexRadarChart.vue?vue&type=style&index=0&id=38d122b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d122b6",
  null
  
)

export default component.exports